import { render, staticRenderFns } from "./PlantCard.vue?vue&type=template&id=3e98a703&scoped=true&"
import script from "./PlantCard.vue?vue&type=script&lang=ts&"
export * from "./PlantCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlantCard.vue?vue&type=style&index=0&id=3e98a703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e98a703",
  null
  
)

export default component.exports